import { ToastService } from './../../services/toast.service';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BallotsService } from 'src/app/services/ballots.service';
import { TurboBallotsRunnerComponent } from '../turbo-ballots-runner/turbo-ballots-runner.component';

@Component({
  selector: 'app-my-ballot',
  templateUrl: './my-ballot.component.html',
  styleUrls: ['./my-ballot.component.scss'],
})
export class MyBallotComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() ballot;
  @Input() showVotesOf: number    // null: apre la scheda senza le percentuali
                                  //  id : apre la scheda con le percentuali
  @Input() showVotesBeforeBallot: boolean  //  true: mostra i punteggi senza passare per la votazione
                                           // false: propone la votazione, poi mostra i punteggi

  @Input() loggedUser: any
  @Output() returnToBallotsPairEvent = new EventEmitter<any>()

  hidden = false;
  animateBeforeDelete = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,  // inutile C/modifiche 11/6/2021
    private modalController: ModalController,
    private elRef: ElementRef,
    private ballotService: BallotsService,
    private toastService: ToastService
  ) { }

  async ngOnInit() {
    //this.showVotesOf = this.ballot.id
    //this.voteInModalAndShowData()
    // DISABILITATO L'11/6/2021
    // -------------------------
    // this.route.params.subscribe(params => {
    //   this.showVotesOf = null;
    //   if (!!params.id && parseInt(params.id, 10) === parseInt(this.ballot.id, 10)) {
    //     this.showVotesOf = params.id;
    //   }
    // });
  }

  async ngOnChanges(){
    if (this.showVotesBeforeBallot){
      this.voteInModalAndShowData()
    } else {
      let id_ballot = this.ballot.id
      const rawMyBallots = await this.ballotService.getMyBallots(true);
      const improvedMyBallots = this.ballotService.improveBallotsList(rawMyBallots);
      this.ballot = improvedMyBallots.find(b => b.id === id_ballot);
      //this.showVotesOf = this.ballot.id;                          // Modifica 18/6/2021
      this.scrollToId(`#ballot-${this.ballot.id}`);
    }
    console.log(this.ballot)
  }

  ngAfterViewInit() {
    // if (!!this.showVotesOf) {
    //   this.scrollToId(`#ballot-${this.showVotesOf}`);
    // }
  }

  async update() {
    await this.voteInModalAndShowData();
  }

  returnToBallotsPair(myBallotId){ // AGGIORNAMENTO 11/6/2021: ritorna all'elenco dei ballottaggi (returnToBallotsPair)
    //alert("MyBallotComponent/returnToBallotsPair() - id: " + myBallotId)
    const el: HTMLElement = this.elRef.nativeElement.querySelector("#ballot-"+myBallotId.toString());
    el.remove()
    this.returnToBallotsPairEvent.emit(myBallotId)
  }

  async voteInHomeAndComeBackToShowData() {
    await this.router.navigate(['home', this.ballot.id]);
  }

  async voteInModalAndShowData() {
    const modal = await this.modalController.create({
      component: TurboBallotsRunnerComponent,
      showBackdrop: false,
      componentProps: {
        modalMode: true,
        modalTitle: 'Vota per aggiornare',
        modalController: this.modalController
      },
      cssClass: 'vote-modal vote-modal-with-background'
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (!!data && !!data.ballotVoted) {
      const rawMyBallots = await this.ballotService.getMyBallots(true);
      const improvedMyBallots = this.ballotService.improveBallotsList(rawMyBallots);
      this.ballot = improvedMyBallots.find(b => b.id === this.ballot.id);
      this.showVotesOf = this.ballot.id;
      this.scrollToId(`#ballot-${this.showVotesOf}`);
    }
  }

  async delete() {
    // Trigger animation
    this.animateBeforeDelete = true;
    const t = setTimeout(() => {
      this.animateBeforeDelete = false;
      this.hidden = true;
    }, 1000);
    // 7/7/2021: il parametro _refreshMyBallots a true conserva il comportamento originale
    //                                          a false evita il refresh dopo la cancellazione
    const response = await this.ballotService.deleteBallot(this.ballot.id, true);
    if (response.status === 'ok') {
      console.log(`Ballot ${this.ballot.id} Was deleted`);
    }
  }

  scrollToId(elementIdSelector: string) {
    const el: HTMLElement = this.elRef.nativeElement.querySelector(elementIdSelector);
    const t1 = setTimeout(() => {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      clearTimeout(t1);
    }, 0);
  }

}
